import { Box, Grid } from "@mui/material";
import { SubmitHandler, useForm } from "react-hook-form";
import { useEffect } from "react";
import { LoadingButton } from "../../../../components/button/Button";
import Input from "../../../../components/input/Input-v2";
import {
  useAddPaymentMethod,
  useGetPaymentMethod,
  useUpdatePaymentMethod,
} from "../../api/invoice/paymentMethod/resolver";

interface Form {
  idPaymentMethod?: string;
}

export interface Form_Create_PaymentMethod {
  payment_method_name: string;
}

export interface Form_Update_PaymentMethod extends Form_Create_PaymentMethod {
  payment_method_id: string;
}

export default function Form({ idPaymentMethod }: Form) {
  const { mutate: mutateAddSubDealer, isLoading: loadingAddSubDealer } =
    useAddPaymentMethod();
  const { mutate: mutateUpdateSubDealer, isLoading: loadingUpdateSubDealer } =
    useUpdatePaymentMethod();
  const { data: dataRawSubDealer, isLoading: loadingFetchSupplier } =
    useGetPaymentMethod({ payment_method_id: idPaymentMethod });
  const dataPaymentMethod = dataRawSubDealer?.data?.data;
  const isAddFlow = idPaymentMethod === undefined;
  const isLoading = loadingAddSubDealer || loadingUpdateSubDealer;
  const { control, handleSubmit, setValue } =
    useForm<Form_Create_PaymentMethod>({
      defaultValues: {
        payment_method_name: "",
      },
    });

  useEffect(() => {
    if (dataPaymentMethod) {
      setValue("payment_method_name", dataPaymentMethod.payment_method_name);
    }
  }, [dataPaymentMethod]);

  const handleFormSubmit: SubmitHandler<Form_Create_PaymentMethod> = (data) => {
    if (isAddFlow) {
      mutateAddSubDealer({ ...data });
    } else {
      const body: Form_Update_PaymentMethod = {
        payment_method_id: idPaymentMethod,
        ...data,
      };
      mutateUpdateSubDealer({ ...body });
    }
  };

  return (
    <Box>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="payment_method_name"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Text
                  label="Nama Metode Pembayaran"
                  isFetching={loadingFetchSupplier}
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
            gap={2}
          >
            {!isAddFlow && <LoadingButton color="error" text="Hapus" />}
            <LoadingButton
              type="submit"
              isLoading={isLoading}
              text={isAddFlow ? "Tambah" : "Update"}
            />
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
